<template>
  <div class="type-item">
    <i class="el-icon-close close" v-show="closeEnable" @click.self="handleDelete"></i>
    <span class="type-item-content" :title="name" @click="handleClick">{{ name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
    closeEnable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("handleSelected", { index: this.index, name: this.name })
    },
    handleDelete() {
      this.$emit("deleteItem", this.index)
    },
  },
}
</script>

<style lang="scss">
.type-item {
  position: relative;
  display: inline-block;
  box-shadow: 0 0 2px black;
  background-color: #26115e;
  width: 16%;
  //   height: 12%;
  height: 4vh;
  //   min-height: 3vh;
  border-radius: 5px;
  font-size: 10px;
  font-weight: bold;
  padding: 0 3px;
  margin-right: 13px;
  cursor: pointer;
  & .type-item-content {
    display: block;
    width: 100%;
    height: 100%;
    //文字超出不换行，用...显示超出部分
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    //设置居中
    text-align: center;
    line-height: 4vh;
  }
  & .close {
    padding: 2px;
    width: 10px;
    height: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    background-color: #eee;
    color: black;
    font-size: 5px;
    cursor: pointer;
  }
}
</style>
